import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { NAV_LINKS } from '../../lib/constants';
import styles from './PublicHeader.module.css';

interface PublicHeaderProps {
  orgName: string;
  logoUrl: string;
  ctaText: string;
}

export function PublicHeader({ orgName, logoUrl, ctaText }: PublicHeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={`container ${styles.inner}`}>
        <Link to="/" className={styles.brand}>
          {logoUrl ? (
            <img src={logoUrl} alt={orgName} className={styles.logo} />
          ) : null}
          <span className={styles.orgName}>{orgName}</span>
        </Link>

        <nav className={[styles.nav, menuOpen ? styles.open : ''].join(' ')} aria-label="Main navigation">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                [styles.navLink, isActive ? styles.active : ''].join(' ')
              }
              end={link.path === '/'}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/events" className={styles.cta} onClick={() => setMenuOpen(false)}>
          {ctaText}
        </Link>

        <button
          className={styles.menuToggle}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span className={[styles.bar, menuOpen ? styles.barOpen : ''].join(' ')} />
          <span className={[styles.bar, menuOpen ? styles.barOpen : ''].join(' ')} />
          <span className={[styles.bar, menuOpen ? styles.barOpen : ''].join(' ')} />
        </button>
      </div>
    </header>
  );
}
